import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-selected-filters">
                <div className="active-facets__button-wrapper">
                    <h2 class="facets__heading facets__heading--vertical font-secondary mono-sm ns-only-desktop" id="verticalTitle" tabindex="-1">Active filters</h2>
                    <div
                        class="active-facets__button-remove underlined-link font-primary buttons-sm"
                        role="button"
                        onClick={() => {
                            removeAll()
                        }}>
                        <span>Reset All</span>
                    </div>
                </div>
                <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div 
                            key={`${filter.name}: ${filter.value}`}
                            class="active-facets__button active-facets__button--light"
                            onClick={() => filter.remove()}>
                            <span class="active-facets__button-inner button button--tertiary font-secondary mono-sm">
                                {filter.name}: {filter.value}
                                <svg class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z" fill="currentColor"></path></svg>
                                <span class="visually-hidden">Remove filter</span>
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        )
    )
}
